import RestAPIClient from "services/RestAPIClient";

class MetaService extends RestAPIClient {
  constructor() {
    super("meta");
  }

  getMetaData = async (req: {
    kind:
      | "meta_channel"
      | "meta_partner"
      | "meta_ads_type"
      | "meta_device"
      | "meta_country_region"
      | "meta_spend_strategy"
      | "meta_category"
      | "meta_brand"
      | "meta_program";
    limit: number;
    offset: number;
    sort_by?: string;
  }): Promise<any> => {
    const { kind, ...restReq } = req;
    const res = await this.get(`/${kind}`, restReq);
    return res.data;
  };
}

export default new MetaService();
